import React from "react";
import { useParams } from "react-router-dom";
import {
  apiCallPost,
  initials,
  niceDateTime,
  renderCorrectedIop,
  yearFromNow,
} from "../util/util";
import "../Prescription.css";
import QRCode from "react-qr-code";
import { Button, NonIdealState, Spinner, Tag } from "@blueprintjs/core";
import _ from "lodash";
import cogoToast from "cogo-toast";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class PrescriptionLowerOrder extends React.Component {
  state = { isLoading: true, isFailure: false };

  componentDidMount() {
    let ss = this.props.params.visitId;
    if (ss) {
      this.getSubmission(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSubmission = async (ss) => {
    try {
      let res = await apiCallPost("/print/clinical", {
        visitId: ss,
      });
      try {
        let res2 = await apiCallPost("/print/site_info", {
          site: res.landing.todayVisit.branch,
        });
        this.setState({ site_info: res2, clinical: res, isLoading: false });
      } catch (err) {
        cogoToast.error("Failed to load site data.");
        this.setState({ isLoading: false, isFailure: true });
      }
    } catch (err) {
      cogoToast.error("Failed to load clinical data.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };
  renderHeader = () => {
    return (
      <div className="pres-font__x__small">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            /*   backgroundColor: "red", */
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              maxWidth: "48vw",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                alt="Client Logo"
                src={this.state.site_info.logoUrl}
                height="85px"
                width="auto"
                className="pres-img_block"
              />
              <b
                style={{
                  fontSize: "9pt",
                  marginTop: "3px",
                  maxWidth: "100px",
                  textAlign: "center",
                }}
              >
                {this.state.site_info.hospital_name}
              </b>
            </div>
            <div>
              <b> {this.state.site_info.hospital_contact[0]}</b> <br />
              {this.state.site_info.hospital_contact[1]} <br />
              {this.state.site_info.hospital_contact[2]} <br />
              {this.state.site_info.hospital_contact[3]} <br />
              {this.state.site_info.ClinicPh} <br />
              {this.state.site_info.email} <br />
              Eye Bank: {this.state.site_info.EyeBankPh} <br />
              Insurance: {this.state.site_info.InsurancePh}
            </div>
          </div>{" "}
          <div
            style={{
              /*  backgroundColor: "green", */
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            <div style={{ maxWidth: "50vw" }}>
              <b>{this.state.clinical.landing.name} </b>
              {yearFromNow(this.state.clinical.landing.dob)}
              {" / "}
              {this.state.clinical.landing.sex} <br />
              <Tag minimal className="pres-font__x__small">
                {" "}
                PID: <b>{this.state.clinical.landing.sysPid}</b>
              </Tag>
              <br />
              {this.state.clinical.landing.phone} <br />
              {this.state.clinical.landing.address} <br />
              <hr />{" "}
              <Tag minimal className="pres-font__x__small">
                {" "}
                <b>
                  Consultant: {this.state.clinical.landing.todayVisit.doctor}
                </b>
              </Tag>{" "}
              <br />
              Optometrist:{" "}
              {this.state.clinical.landing.todayVisit.vision.visionDoneBy}
              <br />
              {niceDateTime(
                this.state.clinical.landing.todayVisit.appointmentTime
              )}
            </div>
            <div
              style={{
                /*  backgroundColor: "yellow", */
                marginLeft: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <QRCode
                size={80}
                value={`https://print.newchart.care/rx/${this.props.params.visitId}`}
                level="H"
              />
              <div
                style={{
                  fontSize: "x-small",
                  wordBreak: "break-all",
                  maxWidth: "100px",
                  textAlign: "center",
                }}
              >
                <code style={{ textAlign: "center" }}>
                  {" "}
                  {this.state.clinical.landing.todayVisit._id}
                </code>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    );
  };
  /** History */
  renderHistory = () => {
    let allergies = this.state.clinical.landing.allergies.map(
      (each) => each.allergy
    );
    let famHist = this.state.clinical.landing.famHist.map((each) => {
      return each.disease + " " + (each.lineage ? `(${each.lineage})` : "");
    });
    let functionalEyes = this.state.clinical.landing.functionalEyes;
    let prevEyeDx = this.state.clinical.landing.prevEyeDx.map((each) => {
      return (each.site ? initials(each.site) + ": " : "") + each.disease;
    });
    let sysDx = this.state.clinical.landing.sysDx.map((each) => {
      return (
        each.disease +
        (each.since ? ` (Since ${each.since})` : "") +
        (each.onRx ? ", on Rx" : "")
      );
    });
    let sysEyeSx = this.state.clinical.landing.sysEyeSx.map((each) => {
      return (
        (each.eye ? initials(each.eye) + ": " : "") +
        each.surgery +
        (each.anaesthesia ? ` ↓ ${initials(each.anaesthesia)}` : "") +
        (each.outsideDoc ? ` by ${each.outsideDoc}` : "") +
        (each.when ? ` in ${each.when}` : "")
      );
    });
    let sysSx = this.state.clinical.landing.sysSx.map((each) => {
      return each.surgery + (each.when ? ` in ${each.when}` : "");
    });
    let prev_medicines =
      this.state.clinical.landing.todayVisit.prev_medicines.map(
        (each) => each.molecules
      );

    let length = 0;
    let text = null;
    let history = {};
    if (functionalEyes !== "Both Eyes") {
      length++;
      history["Functional Eyes"] = functionalEyes;
    }
    length =
      length +
      allergies.length +
      famHist.length +
      prevEyeDx.length +
      sysDx.length +
      sysEyeSx.length +
      sysSx.length +
      prev_medicines.length;
    if (!length) {
      return null;
    }

    if (length >= 3) {
      text = "HISTORY";
    } else {
      text = "HX";
    }
    history["Allergies"] = allergies;
    history["Family History"] = famHist;
    history["Current Medications"] = prev_medicines;
    history["History of Eye Diseases"] = prevEyeDx;
    history["History of Eye Surgeries"] = sysEyeSx;
    history["Systemic Diseases"] = sysDx;
    history["Systemic Surgeries"] = sysSx;
    return (
      <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}>
        <>{this.renderVerticalText(text)}</>
        <div
          style={{
            marginRight: "10px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            maxHeight: `${length >= 3 ? "12em" : "6em"}`,
          }}
        >
          {this.renderHistoryEach(history)}
        </div>{" "}
      </div>
    );
  };
  renderHistoryEach = (history) => {
    let keys = _.keys(history);
    return keys.map((each) => {
      if (history[each].length) {
        return (
          <div className="pres-vision__workup__tags">
            {" "}
            <Tag minimal className="pres-font__x__small">
              {each}
            </Tag>{" "}
            <Tag
              multiline
              minimal
              className="pres-bg__none pres-font__x__small pres-max45"
            >
              {each === "Functional Eyes"
                ? history[each]
                : history[each].join("; ")}
            </Tag>
          </div>
        );
      } else {
        return null;
      }
    });
  };
  /** History Ends */
  /** Symptoms */
  renderSymptoms = () => {
    let sym = this.state.clinical.landing.todayVisit.symptoms;
    let notes = this.state.clinical.landing.todayVisit.subjectiveNotes;
    if (notes[0].text) {
      sym.push({ site: "*", symptom: notes[0].text });
    }
    if (!sym.length) {
      return null;
    }
    return (
      <div style={{ marginBottom: "10px" }}>
        {this.renderHorizontalText("SYMPTOMS / CONTEXT OF VISIT")}
        <div className="pres-vision__workup__tags">
          {sym.map((each) => {
            return (
              <div
                className="pres-vision__workup__tags"
                style={{ marginRight: "10px" }}
              >
                {" "}
                {each.site ? (
                  <Tag minimal className="pres-font__x__small">
                    {each.site}
                  </Tag>
                ) : null}
                <Tag minimal multiline className="pres-font__x__small">
                  {each.symptom}
                </Tag>
                <Tag
                  minimal
                  multiline
                  className="pres-font__x__small pres-bg__none"
                >
                  {each.onset ? ` - ${each.onset} Onset` : ""}
                  {each.progression ? ` - ${each.progression} Progression` : ""}
                  {each.duration
                    ? ` - For a duration of ${each.duration} `
                    : ""}
                  {each.sinceLastVisit
                    ? ` - ${each.sinceLastVisit} since the last visit`
                    : ""}
                </Tag>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  /**Symptoms End */
  /** Vision */
  renderVisionSection = () => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}>
        <>{this.renderVerticalText("VISION")}</>
        <div style={{ marginRight: "10px" }}>
          {this.renderVisionTable()}
        </div>{" "}
        <>{this.renderVerticalText("WORK UP")}</>
        <div className="pres-font__x__small">
          {this.renderAT()}
          {this.renderNCT()}
          {this.renderCentralCornealThickness()}
          {this.renderPupillaryReaction()}
          {this.renderContrastSensitivity()}
          {this.renderSchirmers()}
          {this.renderWorth()}
          {this.renderColourVision()}
          {this.renderGlassesAge()}
        </div>
      </div>
    );
  };
  renderVisionTable = () => {
    let visionRows = [];
    let visionNice = [];
    if (this.state.clinical.landing.todayVisit.vision.has_uncorrected) {
      visionRows.push(
        this.state.clinical.landing.todayVisit.vision.uncorrected
      );
      visionNice.push("Uncorrected");
    }
    if (this.state.clinical.landing.todayVisit.vision.has_pgp) {
      visionRows.push(this.state.clinical.landing.todayVisit.vision.pgp);
      visionNice.push("PGP");
    }
    if (this.state.clinical.landing.todayVisit.vision.has_corrected_dry) {
      visionRows.push(
        this.state.clinical.landing.todayVisit.vision.corrected_dry
      );
      visionNice.push("Dry");
    }
    if (this.state.clinical.landing.todayVisit.vision.has_corrected_dilated) {
      visionRows.push(
        this.state.clinical.landing.todayVisit.vision.corrected_dilated
      );
      visionNice.push("Dilated ");
    }
    if (this.state.clinical.landing.todayVisit.vision.has_corrected_pmt) {
      visionRows.push(
        this.state.clinical.landing.todayVisit.vision.corrected_pmt
      );
      visionNice.push("PMT");
    }
    if (this.state.clinical.landing.todayVisit.vision.has_corrected_rx) {
      visionRows.push(
        this.state.clinical.landing.todayVisit.vision.corrected_rx
      );
      visionNice.push("Final Rx");
    }
    /** IF Condition */
    return (
      <table className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped pres-font__x__small">
        <thead>
          <tr>
            <th rowSpan={2}> </th>
            <th colSpan={3}>
              <Tag className="pres-font__x__small" minimal>
                Right Eye
              </Tag>
            </th>
            <th colSpan={3}>
              <Tag className="pres-font__x__small" minimal>
                Left Eye
              </Tag>
            </th>
          </tr>
          <tr className="pres-font__x__small">
            <th>Distance</th>
            <th>Pinhole</th>
            <th>Near</th>
            <th>Distance</th>
            <th>Pinhole</th>
            <th>Near</th>
          </tr>
        </thead>
        <tbody>{this.renderVisionRows(visionRows, visionNice)}</tbody>
      </table>
    );
  };
  renderVisionRows = (visionRows, visionNice) => {
    return visionRows.map((each, index) => {
      return (
        <tr className="pres-font__x__small">
          <td>{visionNice[index]}</td>
          <td>{each.re.v_dist === "---" ? "" : each.re.v_dist}</td>
          <td>{each.re.v_ph === "---" ? "" : each.re.v_ph}</td>
          <td>{each.re.v_near === "---" ? "" : each.re.v_near}</td>
          <td>{each.le.v_dist === "---" ? "" : each.le.v_dist}</td>
          <td>{each.le.v_ph === "---" ? "" : each.le.v_ph}</td>
          <td>{each.le.v_near === "---" ? "" : each.le.v_near}</td>
        </tr>
      );
    });
  };
  renderNCT = () => {
    if (
      this.state.clinical.landing.todayVisit.vision.nct.le !== "---" ||
      this.state.clinical.landing.todayVisit.vision.nct.re !== "---"
    ) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            IOP (NCT)
          </Tag>
          {this.state.clinical.landing.todayVisit.vision.nct.re ===
          "---" ? null : (
            <Tag
              minimal
              multiline
              className="pres-bg__none pres-font__x__small"
            >
              RE: {this.state.clinical.landing.todayVisit.vision.nct.re}{" "}
              {this.state.clinical.landing.todayVisit.vision.cct.re
                ? `(Adj: ${renderCorrectedIop(
                    this.state.clinical.landing.todayVisit.vision.cct.re,
                    this.state.clinical.landing.todayVisit.vision.nct.re
                  )}) `
                : ""}
              mm Hg
            </Tag>
          )}
          {this.state.clinical.landing.todayVisit.vision.nct.le ===
          "---" ? null : (
            <Tag
              minimal
              multiline
              className="pres-bg__none pres-font__x__small"
            >
              LE: {this.state.clinical.landing.todayVisit.vision.nct.le}{" "}
              {this.state.clinical.landing.todayVisit.vision.cct.le
                ? `(Adj: ${renderCorrectedIop(
                    this.state.clinical.landing.todayVisit.vision.cct.le,
                    this.state.clinical.landing.todayVisit.vision.nct.le
                  )}) `
                : ""}{" "}
              mm Hg
            </Tag>
          )}
        </div>
      );
    }
  };
  renderAT = () => {
    if (
      this.state.clinical.landing.todayVisit.vision.at.le !== "---" ||
      this.state.clinical.landing.todayVisit.vision.at.re !== "---"
    ) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            IOP (AT)
          </Tag>
          {this.state.clinical.landing.todayVisit.vision.at.re ===
          "---" ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              RE: {this.state.clinical.landing.todayVisit.vision.at.re}{" "}
              {this.state.clinical.landing.todayVisit.vision.cct.re
                ? `(Adj: ${renderCorrectedIop(
                    this.state.clinical.landing.todayVisit.vision.cct.re,
                    this.state.clinical.landing.todayVisit.vision.at.re
                  )}) `
                : ""}{" "}
              mm Hg
            </Tag>
          )}
          {this.state.clinical.landing.todayVisit.vision.at.le ===
          "---" ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              LE: {this.state.clinical.landing.todayVisit.vision.at.le}{" "}
              {this.state.clinical.landing.todayVisit.vision.cct.le
                ? `(Adj: ${renderCorrectedIop(
                    this.state.clinical.landing.todayVisit.vision.cct.le,
                    this.state.clinical.landing.todayVisit.vision.at.le
                  )}) `
                : ""}{" "}
              mm Hg
            </Tag>
          )}
        </div>
      );
    }
  };
  renderPupillaryReaction = () => {
    if (
      this.state.clinical.landing.todayVisit.vision.pupillaryReaction.le ||
      this.state.clinical.landing.todayVisit.vision.pupillaryReaction.re
    ) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            Pupillary Reaction
          </Tag>
          {!this.state.clinical.landing.todayVisit.vision.pupillaryReaction
            .re ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              RE:{" "}
              {
                this.state.clinical.landing.todayVisit.vision.pupillaryReaction
                  .re
              }
            </Tag>
          )}
          {!this.state.clinical.landing.todayVisit.vision.pupillaryReaction
            .le ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              LE:{" "}
              {
                this.state.clinical.landing.todayVisit.vision.pupillaryReaction
                  .le
              }
            </Tag>
          )}
        </div>
      );
    }
  };
  renderContrastSensitivity = () => {
    if (
      this.state.clinical.landing.todayVisit.vision.contrast.le ||
      this.state.clinical.landing.todayVisit.vision.contrast.re
    ) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            Contrast Sensitivity
          </Tag>
          {!this.state.clinical.landing.todayVisit.vision.contrast.re ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              RE: {this.state.clinical.landing.todayVisit.vision.contrast.re}
            </Tag>
          )}
          {!this.state.clinical.landing.todayVisit.vision.contrast.le ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              LE: {this.state.clinical.landing.todayVisit.vision.contrast.le}
            </Tag>
          )}
        </div>
      );
    }
  };
  renderCentralCornealThickness = () => {
    if (
      this.state.clinical.landing.todayVisit.vision.cct.le ||
      this.state.clinical.landing.todayVisit.vision.cct.re
    ) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            CCT
          </Tag>
          {!this.state.clinical.landing.todayVisit.vision.cct.re ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              RE: {this.state.clinical.landing.todayVisit.vision.cct.re} µm
            </Tag>
          )}
          {!this.state.clinical.landing.todayVisit.vision.cct.le ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              LE: {this.state.clinical.landing.todayVisit.vision.cct.le} µm
            </Tag>
          )}
        </div>
      );
    }
  };

  renderSchirmers = () => {
    if (
      this.state.clinical.landing.todayVisit.vision.schirmer.le ||
      this.state.clinical.landing.todayVisit.vision.schirmer.re
    ) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            Schirmer's Test
          </Tag>
          {!this.state.clinical.landing.todayVisit.vision.schirmer.re ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              RE: {this.state.clinical.landing.todayVisit.vision.schirmer.re}
            </Tag>
          )}
          {!this.state.clinical.landing.todayVisit.vision.schirmer.le ? null : (
            <Tag minimal className="pres-bg__none pres-font__x__small">
              LE: {this.state.clinical.landing.todayVisit.vision.schirmer.le}
            </Tag>
          )}
        </div>
      );
    }
  };
  renderWorth = () => {
    if (this.state.clinical.landing.todayVisit.vision.worth) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            Worth's Four Dot Test
          </Tag>

          <Tag minimal className="pres-bg__none pres-font__x__small">
            {this.state.clinical.landing.todayVisit.vision.worth}
          </Tag>
        </div>
      );
    }
  };
  renderGlassesAge = () => {
    if (this.state.clinical.landing.todayVisit.vision.glassesAge) {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            Current Glasses Age
          </Tag>

          <Tag minimal className="pres-bg__none pres-font__x__small">
            {this.state.clinical.landing.todayVisit.vision.glassesAge}
          </Tag>
        </div>
      );
    }
  };
  renderColourVision = () => {
    if (this.state.clinical.landing.colorVision !== "Not Tested") {
      return (
        <div className="pres-vision__workup__tags">
          <Tag minimal className="pres-font__x__small">
            Colour Vision
          </Tag>

          <Tag minimal className="pres-bg__none pres-font__x__small">
            {this.state.clinical.landing.colorVision}
          </Tag>
        </div>
      );
    }
  };
  /** Vision Ends */
  /** Findings and Investigations */
  renderFnDxInv = () => {
    return (
      <div style={{ display: "flex" }}>
        <div>{this.renderFindings()}</div>
        <div>
          {this.renderDx()}
          {this.renderInv()}
          {this.renderSysInv()}
        </div>
      </div>
    );
  };
  renderDx = () => {
    let eyeDx = this.state.clinical.landing.todayVisit.eyeDx;
    let notes = this.state.clinical.landing.todayVisit.dxNotes;
    if (notes[0].text) {
      eyeDx.push({ site: "", disease: notes[0].text });
    }
    if (!eyeDx.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "10px",
          width: "33vw",
        }}
      >
        {this.renderHorizontalText("DIAGNOSES")}
        {eyeDx.map((each) => {
          return (
            <div className="pres-vision__workup__tags">
              {each.site ? (
                <Tag minimal className="pres-font__x__small">
                  {initials(each.site)}
                </Tag>
              ) : null}
              <Tag
                minimal
                multiline
                className="pres-font__x__small pres-bg__none"
              >
                {each.query ? "? " : ""}
                {each.disease}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderInv = () => {
    let investigations = this.state.clinical.investigations;
    if (!investigations.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "10px",
          width: "33vw",
        }}
      >
        {this.renderHorizontalText("INVESTIGATIONS")}
        {investigations.map((each) => {
          return (
            <div className="pres-vision__workup__tags">
              {each.eye ? (
                <Tag minimal className="pres-font__x__small">
                  {initials(each.eye)}
                </Tag>
              ) : null}
              <Tag
                minimal
                multiline
                className="pres-font__x__small pres-bg__none"
              >
                {each.type}
                {each.subtype ? ` (${each.subtype})` : ""}{" "}
                {each.notes ? ` - ${each.notes}` : ""}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderSysInv = () => {
    let investigations = this.state.clinical.landing.todayVisit.sysinv;
    if (!investigations.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "10px",
          width: "33vw",
        }}
      >
        {investigations.map((each) => {
          let value = "";
          if (each.typeOfTest === "Quantitative") {
            value = each.value + " " + (each.unit || "");
          } else if (each.typeOfTest === "Boolean") {
            value = each.value ? "Positive/Detected" : "Negative/Not Detected";
          } else if (each.typeOfTest === "Narrative") {
            value = each.value;
          }
          return (
            <div className="pres-vision__workup__tags">
              <Tag minimal className="pres-font__x__small">
                {each.testName}
              </Tag>

              <Tag
                minimal
                multiline
                className="pres-font__x__small pres-bg__none"
              >
                {value}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderFindings = () => {
    let findings = this.state.clinical.landing.todayVisit.findings;
    let findingNotes = this.state.clinical.landing.todayVisit.findingNotes
      .map((each) => each.text)
      .join("; ");

    return (
      <div
        style={{
          display: "flex",
          marginBottom: "10px",
        }}
      >
        <>{this.renderVerticalText("EXAMINATION")}</>
        <div>
          <table className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped  pres-font__x__small">
            <thead>
              <tr>
                <th>Anatomy</th>
                <th>Right Eye</th>
                <th>Left Eye</th>
              </tr>
            </thead>
            <tbody>{this.renderFindingsTable(findings)}</tbody>
          </table>
          <div className="pres-font__x__small">{findingNotes}</div>
        </div>
      </div>
    );
  };
  renderFindingsTable = (findings) => {
    let functionalEyes = this.state.clinical.landing.functionalEyes;
    let asn = this.state.clinical.landing.todayVisit.areSectionsNormal;

    for (var i = 0; i < asn.length; i++) {
      let arr = [];
      if (["Both Eyes", "Right Eye"].includes(functionalEyes)) {
        arr.push({ site: "Right Eye", item: "No specific observations" });
      }
      if (["Both Eyes", "Left Eye"].includes(functionalEyes)) {
        arr.push({ site: "Left Eye", item: "No specific observations" });
      }
      let which = asn[i];
      findings[which] = arr;
    }
    let keys = _.keys(findings);
    return keys.map((each) => {
      if (findings[each].length) {
        let r = _.filter(findings[each], (x) => x.site === "Right Eye").length;
        let l = _.filter(findings[each], (x) => x.site === "Left Eye").length;
        let rString = "";
        let lString = "";
        if (r === 0) {
          if (["Both Eyes", "Right Eye"].includes(functionalEyes)) {
            rString = "No specific observations";
          }
        }
        if (l === 0) {
          if (["Both Eyes", "Left Eye"].includes(functionalEyes)) {
            lString = "No specific observations";
          }
        }
        return (
          <tr>
            <td>{each}</td>
            <td>
              {_.filter(findings[each], (x) => x.site === "Right Eye")
                .map((f) => {
                  return (
                    f.item +
                    (f.qualifier ? ` - ${f.qualifier}` : "") +
                    (f.sinceLastVisit
                      ? ` - ${f.sinceLastVisit} since the last visit`
                      : "") +
                    (f.splText ? ` - ${f.splText}` : "")
                  );
                })
                .join("; ") || rString}{" "}
            </td>
            <td>
              {_.filter(findings[each], (x) => x.site === "Left Eye")
                .map((f) => {
                  return (
                    f.item +
                    (f.qualifier ? ` - ${f.qualifier}` : "") +
                    (f.sinceLastVisit
                      ? ` - ${f.sinceLastVisit} since the last visit`
                      : "") +
                    (f.splText ? ` - ${f.splText}` : "")
                  );
                })
                .join("; ") || lString}{" "}
            </td>
          </tr>
        );
      } else {
        return null;
      }
    });
  };
  /**Findings End */
  /**Medicines and Advice */
  renderMedAdv = () => {
    let sx = this.state.clinical.landing.todayVisit.plannedEyeSx.length ? 1 : 0;

    let adv = _.flatten(
      _.concat(
        this.state.clinical.landing.todayVisit.advice,
        this.state.clinical.landing.todayVisit.advNotes[0].text
          ? this.state.clinical.landing.todayVisit.advNotes
          : null,
        this.state.clinical.landing.todayVisit.vision.glassAdvice
      )
    ).length
      ? 1
      : 0;
    let meds = this.state.clinical.landing.todayVisit.medicines.length ? 1 : 0;
    let howMany = sx + adv + meds;
    let ratio = "31vw";
    if (howMany === 2) {
      ratio = "42vw";
    }
    if ((howMany = 1)) {
      ratio = "95vw";
    }
    if (!howMany) {
      return null;
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        {meds ? (
          <div style={{ width: `${ratio}` }}>{this.renderMedicines()}</div>
        ) : null}
        {adv ? (
          <div style={{ width: `${ratio}` }}>{this.renderAdvice()}</div>
        ) : null}
        {sx ? <div style={{ width: `${ratio}` }}>{this.renderSx()}</div> : null}
      </div>
    );
  };
  renderMedicines = () => {
    let meds = this.state.clinical.landing.todayVisit.medicines;
    if (!meds.length) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px",
            marginRight: "10px",
          }}
        >
          <>{this.renderHorizontalText("PRESCRIPTION")}</>
          <div className="pres-font__x__small">
            No additional medicines prescribed at this time. Please adhere to
            instructions and advice given.
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",

          marginRight: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("PRESCRIPTION", true)}</>

        {meds.map((each) => {
          return (
            <div
              className="pres-vision__workup__tags"
              style={{ borderLeft: "2px solid black" }}
            >
              <Tag minimal multiline className="pres-font__small">
                {each.route}
              </Tag>
              <Tag minimal multiline className="pres-font__small">
                <b> {`${each.brand}`}</b>
                {` (${each.molecules})`}
              </Tag>
              <Tag minimal multiline className="pres-font__small pres-bg__none">
                {each.eye === "RE"
                  ? "Right Eye"
                  : each.eye === "LE"
                  ? "Left Eye"
                  : each.eye === "BE"
                  ? "Both Eyes"
                  : null}{" "}
                {each.durationText}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderAdvice = () => {
    let adv = this.state.clinical.landing.todayVisit.advice;
    if (this.state.clinical.landing.todayVisit.advNotes[0].text) {
      adv = _.concat(
        this.state.clinical.landing.todayVisit.advice,
        this.state.clinical.landing.todayVisit.advNotes
      );
    }

    if (this.state.clinical.landing.todayVisit.vision.glassAdvice.length) {
      let tt = this.state.clinical.landing.todayVisit.vision.glassAdvice;
      if (tt.includes("Contact Lenses")) {
        _.remove(tt, (each) => each === "Contact Lenses");
        adv.push({ text: "Contact lenses prescribed." });
      }
      if (tt.length) {
        let gg = tt.join(" / ");
        gg += " glasses prescribed.";
        adv.push({ text: gg });
      }
    }
    if (!adv.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("ADVICE", true)}</>

        {adv.map((each) => {
          return (
            <div className="pres-vision__workup__tags">
              <Tag minimal multiline className="pres-font__small pres-bg__none">
                {`${each.text}`}
              </Tag>
              <Tag minimal multiline className="pres-font__small pres-bg__none">
                {each.durationText}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderSx = () => {
    let sx = this.state.clinical.landing.todayVisit.plannedEyeSx.map(
      (each) => each.composeString
    );

    if (!sx.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {sx.length === 1 ? (
          <>{this.renderHorizontalText("SURGERY ADVISED", true)}</>
        ) : (
          <>{this.renderHorizontalText("SURGERIES ADVISED", true)}</>
        )}
        <div>
          {sx.map((each) => {
            return (
              <div className="pres-vision__workup__tags">
                <Tag
                  minimal
                  multiline
                  className="pres-font__small pres-bg__none"
                >
                  {each}
                </Tag>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  /**Medicines and Advice */
  /** Follow Up & Doc */
  renderFUDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>{this.renderFollowUp()}</div> <div>{this.renderDoc()}</div>
      </div>
    );
  };
  renderFollowUp = () => {
    let fuObj = this.state.clinical.landing.todayVisit.followup[0];
    let fuString = "";
    if (fuObj.refer) {
      if (fuObj.when) {
        fuString = `Referred to ${fuObj.referTo} - ${fuObj.when}. `;
      } else {
        fuString = `Referred to ${fuObj.referTo}. `;
      }
      if (fuObj.referralNote) {
        fuString = fuString + " Note: " + fuObj.referralNote;
      }
    } else {
      if (fuObj.when) {
        fuString = `Follow up with your doctor - ${fuObj.when}.`;
      } else {
        fuString = "";
      }
    }
    let fuWith = this.state.clinical.landing.todayVisit.followupWith.map(
      (each) => {
        let eye = each.eye ? `${initials(each.eye)}: ` : "";
        let st = each.subtype === "Generic" ? "" : ` - ${each.subtype}`;
        return eye + each.type + st + " - " + each.when;
      }
    );
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginRight: "10px",
        }}
      >
        <>{this.renderHorizontalText("FOLLOW UP")}</>
        {fuString ? (
          <div>
            <Tag multiline minimal className="pres-max45 pres-font__x__small">
              {fuString}
            </Tag>
          </div>
        ) : (
          <div>
            <Tag multiline minimal className="pres-max45 pres-font__x__small">
              Regular check up recommended.
            </Tag>
          </div>
        )}

        <div>
          <Tag
            multiline
            minimal
            className="pres-max45 pres-bg__none pres-font__x__small"
          >
            Contact the hospital for any issues, pain, discharge, drop of vision
            or discomfort.
          </Tag>
        </div>
        <div>
          {fuWith.length ? (
            <Tag minimal multiline className="pres-font__x__small">
              Follow Up with:
            </Tag>
          ) : null}
          {fuWith.map((each) => {
            return (
              <div className="pres-vision__workup__tags">
                <Tag
                  minimal
                  multiline
                  className="pres-font__x__small pres-bg__none"
                >
                  {each}
                </Tag>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  renderDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "right",
        }}
      >
        <>{this.renderHorizontalText("DOCTOR")}</>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="pres-font__small">
            <b>{this.state.clinical.resource.name}</b>
          </div>
          <div className="pres-font__small">
            <b>{this.state.clinical.resource.qualifications}</b>
          </div>
          <div className="pres-font__small">
            Registration: <b>{this.state.clinical.resource.mrNumber}</b>
          </div>
        </div>
      </div>
    );
  };

  /** Follow Up & Doc */
  renderVerticalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          textOrientation: "upright",
          writingMode: "vertical-rl",
          marginRight: "10px",
          fontSize: "xx-small",
          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "xx-small",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="pres-center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="pres-center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div className="pres-rx__container" style={this.printStyle}>
        <style type="text/css" media="print">
          {" @page { size: A4 portrait !important; margin: 3mm !important;"}
        </style>
        <div className="pres-no__print">
          <Button
            icon="print"
            text="Print"
            onClick={() => {
              window.print();
            }}
            fill
          />{" "}
          <br />
          <br />
        </div>
        {this.renderHeader()}
        {this.renderHistory()}
        {this.renderSymptoms()}
        {this.renderVisionSection()} <hr />
        {this.renderFnDxInv()}
        {this.renderMedAdv()}
        {this.renderFUDoc()}
      </div>
    );
  }
}

const Prescription = withRouter(PrescriptionLowerOrder);
export default Prescription;
